export default "__VITE_ASSET__Bqmb6jjK__"